import CreateItemButton from "components/buttons/create";
import { List } from "components";
import { PermissionControlledInput } from "permissions/components/input";
import React from "react";
import { useParams } from "react-router-dom";
import { DateCell, RelativeDateCell } from "@/components/date/cell";
import HeaderPortal from "components/portal/header-portal";

export default function BillableExtensions() {
  const { billableId } = useParams();

  const fields = [
    "id",
    "billing_date",
    "start_date",
    "justification",
    "date_created",
  ];

  const columns = [
    {
      id: "start_date",
      header: "Start Date",
      accessorKey: "start_date",
      cell: DateCell,
    },
    {
      id: "billing_date",
      header: "Billing Date",
      accessorKey: "billing_date",
      cell: DateCell,
    },
    {
      id: "justification",
      header: "Justification",
      accessorKey: "justification",

      sortable: false,
    },
    {
      id: "date_created",
      header: "Created",
      accessorKey: "date_created",
      cell: RelativeDateCell,
    },
  ];

  const defaultFilters = {
    billable: {
      id: {
        _eq: billableId,
      },
    },
  };

  return (
    <div className="p-2 flex-1 overflow-auto">
      <HeaderPortal>
        <PermissionControlledInput
          rule="create:SC,AM"
          collection="billable_extensions"
          showWhenDisabled={false}
        >
          <CreateItemButton href>Extension</CreateItemButton>
        </PermissionControlledInput>
      </HeaderPortal>

      <List
        title="Extensions"
        storageKey={billableId}
        endPoint="billable_extensions"
        filters={defaultFilters}
        columns={columns}
        meta={{ fields }}
        // hidePagination={true}
        showSearch={false}
      />
    </div>
  );
}
